import { type Metric } from '../vessel_data'

export enum EngineMetric {
  enginePortExhaustTemp = 'enginePortExhaustTemp',
  enginePortFuelConsumption = 'enginePortFuelConsumption',
  enginePortRpmTurbocharger = 'enginePortRpmTurbocharger',
  enginePortPower = 'enginePortPower',
  enginePortRpm = 'enginePortRpm',
  engineStbdExhaustTemp = 'engineStbdExhaustTemp',
  engineStbdFuelConsumption = 'engineStbdFuelConsumption',
  engineStbdRpmTurbocharger = 'engineStbdRpmTurbocharger',
  engineStbdPower = 'engineStbdPower',
  engineStbdRpm = 'engineStbdRpm',

  // 3 - used on Obsidian to power Electric generator
  engine3ExhaustTemp = 'engine3ExhaustTemp',
  engine3FuelConsumption = 'engine3FuelConsumption',
  engine3RpmTurbocharger = 'engine3RpmTurbocharger',
  engine3Power = 'engine3Power',
  engine3Rpm = 'engine3Rpm',

  // 4 - used on Obsidian to power Electric generator
  engine4ExhaustTemp = 'engine4ExhaustTemp',
  engine4FuelConsumption = 'engine4FuelConsumption',
  engine4RpmTurbocharger = 'engine4RpmTurbocharger',
  engine4Power = 'engine4Power',
  engine4Rpm = 'engine4Rpm',

  // 5 - used on Obsidian to power Electric generator
  engine5ExhaustTemp = 'engine5ExhaustTemp',
  engine5FuelConsumption = 'engine5FuelConsumption',
  engine5RpmTurbocharger = 'engine5RpmTurbocharger',
  engine5Power = 'engine5Power',
  engineRpm = 'engineRpm',

  // EPM - Electric Powertrain
  engineEpmPortPower = 'engineEpmPortPower',
  engineEpmPortRpm = 'engineEpmPortRpm',
  engineEpmStbdPower = 'engineEpmStbdPower',
  engineEpmStbdRpm = 'engineEpmStbdRpm'
}

export type EngineMetricName = keyof typeof EngineMetric

export type EngineMetrics = Record<EngineMetricName, Metric>

export const allEngineMetricNames: EngineMetricName[] = Object.values(EngineMetric)
